import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Upload,
  Card,
  Select,
} from "antd";
import Main from "../../components/layout/Main";
import { useKYC } from "../../context/KycContext";

const { Option } = Select;

const KYCIndex = () => {
  const { submitKYC, fetchKYC } = useKYC(); // assuming fetchKYC API exists
  const [form] = Form.useForm();
  const [civilIdFile, setCivilIdFile] = useState(null);
  const [passportFile, setPassportFile] = useState(null);
  const [facialIdFile, setFacialIdFile] = useState(null);
  const [kycData, setKycData] = useState(null);
  const [loading, setLoading] = useState(true);
  const fileTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
  const getKyc = async () => {
    try {
      const res = await fetchKYC(); // call your API
      if (res?.status === 200 && res?.data) {
        setKycData(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch KYC:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getKyc();
  }, []);

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("fullName", values.fullName || "");
      formData.append("dateOfBirth", values.dateOfBirth || "");
      if (civilIdFile) formData.append("civilIdPhoto", civilIdFile);
      if (passportFile) formData.append("passportPhoto", passportFile);
      if (facialIdFile) formData.append("facialIdPhoto", facialIdFile);

      const res = await submitKYC(formData);

      if (res?.status === 200 || res?.status === 201) {
        // message.success("KYC submitted successfully!");
        form.resetFields();
        setCivilIdFile(null);
        setPassportFile(null);
        setFacialIdFile(null);
        setKycData(res.data); // show card after submit
        getKyc();
      }
    } catch (err) {
      console.error("KYC submit failed:", err);
      message.error("Failed to submit KYC");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <Main>
      <div className="section-main">
        <div className="active-heading-div">
          <h1>Know Your Customer</h1>

          {kycData ? (
            <div>
              <Card
                bordered
                className="new-main_divhhg"
                style={{
                  width: 600,
                }}
              >
                <h1 className="mb-2">KYC Details</h1>
                <p>
                  <strong>Full Name:</strong> {kycData.fullName}
                </p>
                <p>
                  <strong>Date of Birth:</strong>{" "}
                  {new Date(kycData.dateOfBirth).toLocaleDateString()}
                </p>
                <p>
                  <strong>Kyc No:</strong> {kycData.kycId}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    style={{
                      padding: "4px 10px",
                      borderRadius: "12px",
                      color: "#fff",
                      backgroundColor:
                        kycData.status === "Approved"
                          ? "#52c41a"
                          : kycData.status === "Rejected"
                          ? "#f5222d"
                          : "#faad14",
                    }}
                  >
                    {kycData.status}
                  </span>
                </p>
              </Card>
            </div>
          ) : (
            // Show KYC form if no data
            <Form
              layout="vertical"
              form={form}
              className="edit-profile-form"
              onFinish={handleSubmit}
            >
              <Row>
                <Col span={24} md={12}>
                  <Form.Item
                    label="Full Legal Name"
                    name="fullName"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value || value.trim() === "") {
                            if (!value) {
                              return Promise.reject(
                                new Error("Please enter your Full Name")
                              );
                            } else {
                              return Promise.reject(
                                new Error(
                                  "Full Name cannot be empty or just spaces"
                                )
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <Input
                      className="profile-input"
                      placeholder="Alex Morgan"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Date of Birth"
                    name="dateOfBirth"
                    rules={[
                      { required: true, message: "Date of birth is required" },
                    ]}
                  >
                    <Input
                      className="profile-input"
                      type="date"
                      min="1900-01-01"
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Civil ID Photo"
                    name="civilIdPhoto"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!civilIdFile) {
                            return Promise.reject(
                              new Error("Please upload your Civil ID Photo!")
                            );
                          }

                          if (!fileTypes.includes(civilIdFile.type)) {
                            return Promise.reject(
                              new Error(
                                "Only JPG, PNG, or PDF files are allowed!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Upload
                      beforeUpload={(file) => {
                        setCivilIdFile(file);
                        return false;
                      }}
                      maxCount={1}
                    >
                      <Button className="upload_buton_mainjj_12">
                        Upload Civil ID Photo
                      </Button>
                    </Upload>
                  </Form.Item>

                  <Form.Item
                    label="Passport"
                    name="passportPhoto"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!passportFile) {
                            return Promise.reject(
                              new Error("Please upload your Passport Photo!")
                            );
                          }

                          if (!fileTypes.includes(passportFile.type)) {
                            return Promise.reject(
                              new Error(
                                "Only JPG, PNG, or PDF files are allowed!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Upload
                      beforeUpload={(file) => {
                        setPassportFile(file);
                        return false;
                      }}
                      maxCount={1}
                    >
                      <Button className="upload_buton_mainjj_12">
                        Upload Passport Photo
                      </Button>
                    </Upload>
                  </Form.Item>

                  <Form.Item
                    label="Facial ID Verification"
                    name="facialIdPhoto"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!facialIdFile) {
                            return Promise.reject(
                              new Error("Please upload your  Photo!")
                            );
                          }

                          if (!fileTypes.includes(facialIdFile.type)) {
                            return Promise.reject(
                              new Error(
                                "Only JPG, PNG, or PDF files are allowed!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Upload
                      beforeUpload={(file) => {
                        setFacialIdFile(file);
                        return false;
                      }}
                      maxCount={1}
                    >
                      <Button className="upload_buton_mainjj_12">
                        Take a photo of yourself
                      </Button>
                    </Upload>
                  </Form.Item>

                  <div className="edit-profile-actions">
                    <Button
                      className="social-btn"
                      onClick={() => {
                        form.resetFields();
                        setCivilIdFile(null);
                        setPassportFile(null);
                        setFacialIdFile(null);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      // htmlType="submit"
                      className="fill-button-smal"
                      onClick={() => handleSubmit(form.getFieldsValue(true))}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </div>
    </Main>
  );
};

export default KYCIndex;
